import Vue from 'vue';
import Vuetify from 'vuetify';
import { Context } from '@nuxt/types';
import icons from '~/settings/icons';
import theme from '~/settings/theme';
import asterisk from '~/components/asterisk.vue';
import radioOff from '~/components/common/radioOff.vue';
import radioOn from '~/components/common/radioOn.vue';
const values = icons(Vue);

Vue.use(Vuetify);

export default (context: Context, inject: (name: string, value: unknown) => void) => {
    context.app.vuetify = new Vuetify({
        theme,
        icons: {
            iconfont: 'fa',
            values: {
                ...values,
                asterisk: {
                    // name of our custom icon
                    component: asterisk, // our custom component
                },
                radioOff : {
                    component : radioOff,
                },
                radioOn : {
                    component : radioOn,
                },
            },
        },
    });
    context.$vuetify = context.app.vuetify;
};
